import styled from 'styled-components';

const buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* Lista de botoes rola internamente quando nao cabe na altura da tela,
     mantendo o botao de logout sempre visivel no rodape. flex: 1 ocupa o
     espaco disponivel; min-height: 0 permite o encolhimento dentro do flex
     column do Frame. Scrollbar discreta. */
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 3px;
  }
`;

const logout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  padding: 10px;
  color: #ffffff;
  font-size: 2.5rem;
  /* Nao encolhe: fica fixo no rodape mesmo com a lista rolando. */
  flex-shrink: 0;
`;

const Wrapper = {
  Buttons: buttons,
  Logout: logout,
};

export default Wrapper;
